import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Card, CardContent, Stack } from '@mui/material';
import { LoadingWrapper } from '../loading';

const DashboardSection = ({
  title,
  children,
  isLoading = false,
  skeletonCount = 4,
  gridProps = { xs: 12, sm: 6, md: 3 },
  skeletonVariant = 'stat',
  sx = {},
}) => (
  <Grid item xs={12} sx={sx}>
    <Typography variant="h6" sx={{ mb: 1, px: 2 }}>
      {title}
    </Typography>
    <LoadingWrapper
      isLoading={isLoading}
      skeletonCount={skeletonCount}
      gridProps={gridProps}
      skeletonVariant={skeletonVariant}
    >
      <Grid container spacing={2}>
        {children}
      </Grid>
    </LoadingWrapper>
  </Grid>
);

DashboardSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  skeletonCount: PropTypes.number,
  gridProps: PropTypes.object,
  skeletonVariant: PropTypes.oneOf(['stat', 'action', 'wide', 'indicator-summary']),
  sx: PropTypes.object,
};

DashboardSection.defaultProps = {
  isLoading: false,
  skeletonCount: 4,
  gridProps: { xs: 12, sm: 6, md: 3 },
  skeletonVariant: 'stat',
  sx: {},
};

// Simple stat card component for non-navigational stats
export const StatCard = ({ title, icon, value, iconColor = 'primary', mdSize = 3 }) => (
  <Grid item xs={12} sm={6} md={mdSize}>
    <Card>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          {React.cloneElement(icon, { color: iconColor })}
          <Typography variant="h6">{value}</Typography>
        </Stack>
      </CardContent>
    </Card>
  </Grid>
);

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  iconColor: PropTypes.string,
  mdSize: PropTypes.number,
};

StatCard.defaultProps = {
  iconColor: 'primary',
  mdSize: 3,
};

export default DashboardSection;
